module.exports = __webpack_public_path__ + "static/media/22.72afe2b4.mp3";